import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Vérifier si le token existe ET s'il n'est pas expiré
    if (this.authService.isTokenValid()) {
      return true;
    } else {
      console.log('🚫 Accès refusé - Token invalide ou expiré - Redirection vers login');
      // S'assurer que le token expiré est nettoyé
      this.authService.clearToken();
      this.router.navigate(['/login']);
      return false;
    }
  }
}
